export function match(template, visitor) {
    switch(template.type){
        case 'text':
            return visitor.text(template);
        case 'pdf':
            return visitor.pdf(template);
        case 'video':
            return visitor.video(template);
    }
}
export const isDuplicateTemplateName = (name, templates, excludeTemplateId)=>{
    const normalized = name.trim().toLocaleLowerCase();
    if (normalized === '') return false;
    return templates.some((tmpl)=>tmpl.id !== excludeTemplateId && tmpl.name.trim().toLocaleLowerCase() === normalized);
};
